import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { LawFirmFollow } from '../header/LawFirmFollow';
import '../header/law_firm_header.scss';
import { FirmHeaderDecisionsLink } from '../header/FirmHeaderDecisionsLink';
import { EntityCardHeader } from '../../../entity/components/EntityCardComponents';

type Props = {
  firmName: string;
  dateRadiation: string | null;
  decisionCount: number;
  allDecisionsLink: string;
  lawOfficeIdGroup: string;
};

export const LawFirmHeader: FC<Props> = ({
  firmName,
  dateRadiation,
  decisionCount,
  allDecisionsLink,
  lawOfficeIdGroup,
}) => (
  <EntityCardHeader id="law-firm-header">
    <div className="law-firm-header__top-container">
      <div
        className="entity__header__picture law-firm-header__picture"
        style={{ backgroundImage: 'url(/img/icons/entities/law-firm.svg)' }}
      />
      <div className="law-firm-header__title-container">
        <h1 className="entity__header__title law-firm-header__title">
          {firmName}
        </h1>
        <span className="law-firm-header__title-info">
          <FormattedMessage id="law-firm/page/firm/LawFirmHeader.tsx/1" />{' '}
          {dateRadiation ? (
            <span className="law-firm-header__info-important">
              <FormattedMessage id="law-firm/page/firm/LawFirmHeader.tsx/2" />
              {dateRadiation}
            </span>
          ) : (
            ''
          )}
        </span>
        <FirmHeaderDecisionsLink
          decisionCount={decisionCount}
          allDecisionsLink={allDecisionsLink}
        />
        <LawFirmFollow
          lawOfficeIdGroup={lawOfficeIdGroup}
          firmName={firmName}
        />
      </div>
    </div>
  </EntityCardHeader>
);
